import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectUsersFetchFailedAction = {
	type: 'SUBJECT_USERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectUsersFetchFailedAction => ({
	type: 'SUBJECT_USERS_FETCH_FAILED',
	payload,
});
